<div class="box-wrapper">
  <cc-box>
    <div class="container-responsive" content box>
      <mat-table
        matSort
        (matSortChange)="dataSource.sort($event)"
        [dataSource]="dataSource"
      >

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef> {{ 'IVR.LIST.NAME' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <a class="cell-inside text-info" [routerLink]="[element.id]">{{ element.name }}</a>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="author">
          <mat-header-cell *matHeaderCellDef> {{ 'IVR.LIST.AUTHOR' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span class="cell-inside">{{ element.author }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="dates">
          <mat-header-cell *matHeaderCellDef> {{ 'IVR.LIST.DATE_CREATED' | translate }} / {{ 'IVR.LIST.LAST_UPDATE' |
            translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.dates }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="phoneNumbers">
          <mat-header-cell *matHeaderCellDef> {{ 'IVR.LIST.PHONE_NUMBERS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.phoneNumbers }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="workingHours">
          <mat-header-cell *matHeaderCellDef> {{ 'IVR.LIST.WORKING_HOURS' | translate }}</mat-header-cell>
          <mat-cell class="working-hours-cell" *matCellDef="let element">
            <div *ngIf="!element.workingHours.enabled" class="working-hours-wrapper">
              {{ 'IVR.ALWAYS_ON' | translate }}
            </div>
            <ng-container *ngIf="element.workingHours.enabled">
              <div class="working-hours-wrapper" *ngFor="let range of element.workingHours.ranges">
            <span class="working-hours-hours">
              <span *ngFor="let hoursRange of range.hours; let last = last;">
                <span>{{ formatTime(hoursRange.from) }} - {{ formatTime(hoursRange.to) }}</span>
                <span *ngIf="!last">, </span>
              </span>
            </span>
                <span class="working-hours-days">
              <span *ngFor="let day of sortDays(range.days); let last = last;">
                <span>{{ mapNumberToDay(day) }}</span>
                <span *ngIf="!last">,&nbsp;</span>
              </span>
            </span>
              </div>
            </ng-container>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-icon [routerLink]="[element.id]">edit</mat-icon>
            <mat-icon (click)="deleteIvr(element.id)">delete</mat-icon>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

      </mat-table>

      <cc-empty-table-message *ngIf="!dataSource.length">
        <a
          mat-raised-button
          color="primary-full"
          routerLink="/ivr/add"
        >
          <span translate>IVR.ADD_IVR_TITLE</span>
        </a>
      </cc-empty-table-message>
    </div>
  </cc-box>
</div>
